export const wrapping_element_props = {
    transition: {
        duration: 0.8,
        ease: [0.04, 0.62, 0.4, 0.98],
    },
    variants: {
        open: {
            opacity: [0.5, 1],
            height: 'auto',
        },
        close: {
            opacity: 0,
            height: 0,
        },
    },
};
